/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/archives/list-files": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["archives-list"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/archives/jobs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["archives/jobs-list"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/oidc": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Redirect to the OIDC SignIn page and on successful login create a cookie-based authentication session and then redirect back to the redirect_uri.
         *     The redirect_uri origin is validated against configured allowed origins (FrontendURL + AdditionalAllowedOrigins).
         *     Requires redirect_uri query parameter with the full URL to redirect to after sign-in.
         */
        get: operations["/auth/oidc-get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/oidc/exchange": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Exchange an OIDC ID token for OmicsFlow JWT token pair.
         *
         *     IMPORTANT: You must send the ID token (not the access token) from your OIDC provider.
         *     Frontend performs OIDC authentication client-side (e.g., Azure AD, Google, Auth0),
         *     then exchanges the OIDC ID token for OmicsFlow-specific access and refresh tokens.
         *
         *     The ID token must be a valid JWT with 3 parts (header.payload.signature).
         *     The origin is validated against configured allowed origins (FrontendURL + AdditionalAllowedOrigins).
         *
         *     Returns: Access token in response body and sets refresh token as HttpOnly secure cookie.
         */
        post: operations["/auth/oidc/exchange-post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/credentials": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Sign in with credentials (username and password) and directly receive JWT token pair.
         *     Returns access token in response body and sets refresh token as HttpOnly cookie.
         *     The origin is validated against configured allowed origins (FrontendURL + AdditionalAllowedOrigins).
         *     Requires origin query parameter with the frontend origin URL.
         */
        put: operations["/auth/credentials-put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/token": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a new access token pair(access + refresh), Requires the auth with the "TokenExchangeCookie" in the request headers. That cookie is retrieved after one of the sign-in endpoints.
         *     The access token is returned in the response body and the refresh token is attached in the response haders as http secure cookie.
         *     Requires a valid CSFR token.
         */
        get: operations["auth/token-get"];
        /**
         * Refresh an expired access token. Required the refresh token in the request headers.
         *     The access token is stored in an http secure cookie. This endpoint rotates also the refresh token on successful refresh requests.
         *     Requires a valid CSFR token.
         */
        put: operations["auth/token-put"];
        post?: never;
        /**
         * Invalidates the token pair by deleting from the records and invalidating the refresh token http secure cookie.
         *     Also loggs out the token exchange user session if the TokenExchangeCookie cookie is present.
         *     Requires a valid CSFR token.
         */
        delete: operations["auth/token-delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth/csrf-token": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Gets the CSRF token for the current user session. This is used to protect against CSRF attacks. */
        get: operations["auth/csrf-token-get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/fasta": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Creates a new SoftwareSettings. */
        post: operations["fasta-create"];
        /** Deletes a Fasta file. */
        delete: operations["fasta-delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/fasta/list-files": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a list of the FastaFiles. */
        get: operations["fasta-list"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/jobs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a page object with a list for all Jobs belonging to the requested page after applying filtering and pagination conditions specified in the request's query parameters and sorted by a given column name. */
        get: operations["jobs-list"];
        /** Updates a Job specified by a Job Id. */
        put: operations["jobs-update"];
        /** Creates a new Job. */
        post: operations["jobs-create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/jobs/{job_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a Job specified by a Job Id. */
        get: operations["jobs-get"];
        put?: never;
        post?: never;
        /** Delete a Job from its Id. */
        delete: operations["jobs-delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/jobs/{job_id}/abort": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Aborts the execution of the current job batches if any. */
        put: operations["jobs-abort"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/jobs/{job_id}/cancel-pending-batches": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Cancels pending batches for the job by deleting only non-running batches. */
        put: operations["jobs-cancel-pending-batches"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/jobs/{job_id}/resume": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Resumes the execution of the job if it was aborted. */
        put: operations["jobs-resume"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/jobs/{job_id}/steps": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a list of all Steps belonging to a Job. */
        get: operations["jobs/{job_id}/steps-list"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/jobs/{job_id}/steps/{job_pipeline_step_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a step belonging to a Job specified by a step Id. */
        get: operations["jobs/{job_id}/steps/{job_pipeline_step_id}-get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/jobs/{job_id}/steps/{job_pipeline_step_id}/batches": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a list of all Batches belonging to a Job. */
        get: operations["jobs/{job_id}/steps/{job_pipeline_step_id}/batches-list"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/jobs/{job_id}/steps/{job_pipeline_step_id}/batches/{batch_id}/logs/{session_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Starts a websocket connection to send logs belonging to a Batch. */
        get: operations["jobs/{job_id}/steps/{job_pipeline_step_id}/batches/{batch_id}/logs/{session_id}-get"];
        put?: never;
        /** Stops a websocket connection to send logs belonging to a Batch. */
        post: operations["jobs/{job_id}/steps/{job_pipeline_step_id}/batches/{batch_id}/logs/{session_id}-post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/jobs/{job_id}/steps/{job_pipeline_step_id}/batches/{batch_id}/results/{session_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Gets the results file for a batch. */
        get: operations["jobs/{job_id}/steps/{job_pipeline_step_id}/batches/{batch_id}/results/{session_id}-get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/jobs/{job_id}/steps/{job_pipeline_step_id}/batches/{batch_id}/samples": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a list of all samples of a job batch. */
        get: operations["jobs/{job_id}/steps/{job_pipeline_step_id}/batches/{batch_id}/samples-list"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/libraries/list-files": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["libraries-list"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/libraries/upload": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["libraries-upload"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/license": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Add a new license key. */
        post: operations["license-post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/pipelines/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a Pipeline specified by its Id. */
        get: operations["pipelines-get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/pipelines/{pipeline_id}/steps": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get the list of steps from a Pipeline specified by the Pipeline Id. */
        get: operations["pipelines-steps-get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/jobs/{job_id}/results": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns a pre-computed object URL for the requested job/analysis result. */
        get: operations["-get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sample-inventory/list-files": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a list of the RawFiles. */
        get: operations["sample-inventory-list"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sample-inventory/upload": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Upload a raw file to storage using streaming. */
        post: operations["sample-inventory-upload"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sample-inventory/upload/init": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Initiates a multipart upload for a raw file. */
        post: operations["sample-inventory-upload-init"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sample-inventory/upload/chunk": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Uploads a chunk of a raw file. */
        post: operations["sample-inventory-upload-chunk"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sample-inventory/upload/complete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Completes a multipart upload for a raw file. */
        post: operations["sample-inventory-upload-complete"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sample-inventory/check": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Check if a raw file already exists and return its size. */
        get: operations["sample-inventory-check"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sample-inventory/check-batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Check if a batch of raw files already exists and return their sizes. */
        post: operations["sample-inventory-check-batch"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/software-settings/spectronaut/{version}/create/{type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Creates a new SoftwareSettings. */
        post: operations["software-settings/spectronaut-create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/software-settings/spectronaut/create/{type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Creates new versionless SoftwareSettings. */
        post: operations["software-settings/spectronaut-create-versionless"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/software-settings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a list of the SoftwareSettings. */
        get: operations["software-settings-list"];
        put?: never;
        post?: never;
        /** Deletes a Software Settings file. */
        delete: operations["software-settings-delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/software-versions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a list of the Software Versions. */
        get: operations["software-versions-list"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/software-versions/{version}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch: operations["software-versions-update"];
        trace?: never;
    };
    "/users": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: operations["users-put"];
        /** Creates a new user with the provided username, display name, and password. */
        post: operations["users-post"];
        /** Deletes a user with the provided user ID. */
        delete: operations["users-delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/me/password": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Changes the password of the currently authenticated user. It validates the request, retrieves the user ID from the claims, and attempts to change the password. */
        put: operations["users/me/password-put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        AddLicenseRequestSchema: {
            licenseKey?: string | null;
        };
        AllowedSoftwareVersionSchema: {
            /** Format: uuid */
            id: string;
            fullVersion: string;
            /** Format: int32 */
            majorVersion: number;
        };
        AuditingFileSchema: {
            /** Format: uuid */
            jobId: string;
            /** Format: uuid */
            stepId: string;
            /** Format: uuid */
            batchId: string;
            /** Format: uuid */
            sessionId: string;
            start: boolean;
            fileType: components["schemas"]["FileTypeEnumSchema"];
        };
        BatchRawFileSchema: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            batchId: string;
            location: string;
            fileName: string;
            /** Format: int64 */
            sizeInBytes: number;
            /** Format: int64 */
            fileCount?: number | null;
        };
        BatchSchema: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            stepId: string;
            /** Format: uuid */
            jobId: string;
            /** Format: uuid */
            volumeId: string;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            startedAt?: string | null;
            /** Format: date-time */
            finishedAt?: string | null;
            status: components["schemas"]["StatusEnumSchema"];
            /** Format: int32 */
            progress?: number | null;
            fastaFiles?: string[] | null;
            libraryFiles?: string[] | null;
            rawFileIds: string[];
            rawFileNames?: string[] | null;
        };
        ChangeMyPasswordSchema: {
            currentPassword: string;
            newPassword: string;
            confirmNewPassword: string;
        };
        CheckRawFilesSchema: {
            fileNames?: string[] | null;
            folder?: string | null;
        };
        CompleteRawFileUploadSchema: {
            uploadId?: string | null;
            partTokens?: string[] | null;
            fileName?: string | null;
            folder?: string | null;
            mD5Hash?: string | null;
        };
        CreateJobSchema: {
            quoteNumber?: string | null;
            name: string;
            analysisName?: string | null;
            description?: string | null;
            software: components["schemas"]["SoftwareEnumSchema"];
            softwareSettingsFile?: string | null;
            conditionSetupFile?: string | null;
            modificationRepoFile?: string | null;
            reportSettingsFiles?: string[] | null;
            goFiles?: string[] | null;
            rawFiles?: components["schemas"]["FileMetadataSchema"][] | null;
            fastaFiles: string[];
            pattern?: string | null;
            outputPath?: string | null;
            softwareVersion?: string | null;
            /** Format: int32 */
            batchSize?: number;
            storageLocation?: components["schemas"]["StorageLocationTypeEnumSchema"];
            priority?: components["schemas"]["JobPriorityEnumSchema"];
            pipelineType?: components["schemas"]["JobPipelineTypeSchema"];
            libraryFiles?: components["schemas"]["FileMetadataSchema"][] | null;
            archiveFiles?: components["schemas"]["FileMetadataSchema"][] | null;
            mergeNodePoolOverride?: string | null;
            /** Format: uuid */
            resumeFromStepId?: string | null;
            /** Format: date-time */
            sourceCreatedAt?: string | null;
            sourceJobName?: string | null;
            sourceAnalysisName?: string | null;
        };
        CreateUserSchema: {
            username: string;
            password: string;
            displayName: string;
            /** Format: email */
            email: string;
        };
        ExchangeOidcTokenSchema: {
            oidcToken?: string | null;
        };
        FastaFileSchema: {
            createdBy: string;
            location: string;
            fileName: string;
            /** Format: int64 */
            size: number;
        };
        FileMetadataSchema: {
            path: string;
            /** Format: int64 */
            sizeInBytes: number;
            /** Format: date-time */
            createdAt?: string | null;
            /** Format: int64 */
            fileCount?: number | null;
        };
        /** @enum {string} */
        FileTypeEnumSchema: FileTypeEnumSchema;
        HttpValidationProblemDetailsSchema: {
            type?: string | null;
            title?: string | null;
            /** Format: int32 */
            status?: number | null;
            detail?: string | null;
            instance?: string | null;
            errors?: {
                [key: string]: string[];
            } | null;
        } & {
            [key: string]: unknown;
        };
        InitiateRawFileUploadSchema: {
            fileName?: string | null;
            folder?: string | null;
            /** Format: int64 */
            fileLength?: number;
        };
        JobArchiveCandidateSchema: {
            /** Format: uuid */
            id?: string;
            name?: string | null;
            analysisName?: string | null;
            /** Format: date-time */
            createdAt?: string;
            archivesPath?: string | null;
        };
        JobPipelineStepDetailSchema: {
            /** Format: uuid */
            id: string;
            name: string;
            type: components["schemas"]["SNStepEnumSchema"];
            /** Format: int32 */
            position: number;
            isParallel: boolean;
            /** Format: int32 */
            progress: number;
            status: components["schemas"]["StatusEnumSchema"];
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            startedAt?: string | null;
            /** Format: date-time */
            finishedAt?: string | null;
            /** Format: int32 */
            runningBatchesCount?: number;
            /** Format: int32 */
            completedBatchesCount?: number;
            /** Format: int32 */
            failedBatchesCount?: number;
            /** Format: int32 */
            batchesCount?: number;
        };
        JobPipelineStepSchema: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            jobId: string;
            /** Format: uuid */
            pipelineStepId: string;
            status: components["schemas"]["StatusEnumSchema"];
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            startedAt?: string | null;
            /** Format: date-time */
            finishedAt?: string | null;
            /** Format: int32 */
            progress?: number;
        };
        /** @enum {string} */
        JobPipelineTypeSchema: JobPipelineTypeSchema;
        /** @enum {string} */
        JobPriorityEnumSchema: JobPriorityEnumSchema;
        JobSchema: {
            /** Format: uuid */
            id: string;
            createdBy: string;
            name: string;
            analysisName?: string | null;
            software: components["schemas"]["SoftwareEnumSchema"];
            softwareSettingsFile?: string | null;
            conditionSetupFile?: string | null;
            modificationRepositoryFile?: string | null;
            fastaFiles?: string[] | null;
            libraryFiles?: string[] | null;
            archiveFiles?: string[] | null;
            rawFiles?: string[] | null;
            reportSettingsFile?: string[] | null;
            goFile?: string[] | null;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            startedAt?: string | null;
            /** Format: date-time */
            finishedAt?: string | null;
            /** Format: uuid */
            currentStep?: string | null;
            outputPath?: string | null;
            description?: string | null;
            status: components["schemas"]["StatusEnumSchema"];
            /** Format: int32 */
            progress?: number;
            priority: components["schemas"]["JobPriorityEnumSchema"];
            softwareVersion: string;
            pipelineType?: components["schemas"]["JobPipelineTypeSchema"];
            /** Format: int32 */
            failedBatchesCount?: number;
            mergeNodePoolOverride?: string | null;
        };
        LicenseSchema: Record<string, never>;
        PagedBatchListSchema: {
            /** Format: int32 */
            currentPage?: number;
            /** Format: int32 */
            totalPages?: number;
            /** Format: int32 */
            pageSize?: number;
            /** Format: int32 */
            totalCount?: number;
            list?: components["schemas"]["BatchSchema"][] | null;
        };
        PagedBatchRawFileListSchema: {
            /** Format: int32 */
            currentPage?: number;
            /** Format: int32 */
            totalPages?: number;
            /** Format: int32 */
            pageSize?: number;
            /** Format: int32 */
            totalCount?: number;
            list?: components["schemas"]["BatchRawFileSchema"][] | null;
        };
        PagedFastaFileListSchema: {
            /** Format: int32 */
            currentPage?: number;
            /** Format: int32 */
            totalPages?: number;
            /** Format: int32 */
            pageSize?: number;
            /** Format: int32 */
            totalCount?: number;
            list?: components["schemas"]["FastaFileSchema"][] | null;
        };
        PagedJobListSchema: {
            /** Format: int32 */
            currentPage?: number;
            /** Format: int32 */
            totalPages?: number;
            /** Format: int32 */
            pageSize?: number;
            /** Format: int32 */
            totalCount?: number;
            list?: components["schemas"]["JobSchema"][] | null;
        };
        PagedRawFileListSchema: {
            /** Format: int32 */
            currentPage?: number;
            /** Format: int32 */
            totalPages?: number;
            /** Format: int32 */
            pageSize?: number;
            /** Format: int32 */
            totalCount?: number;
            list?: components["schemas"]["RawFileSchema"][] | null;
        };
        PagedSoftwareSettingsMetadataListSchema: {
            /** Format: int32 */
            currentPage?: number;
            /** Format: int32 */
            totalPages?: number;
            /** Format: int32 */
            pageSize?: number;
            /** Format: int32 */
            totalCount?: number;
            list?: components["schemas"]["SoftwareSettingsMetadataSchema"][] | null;
        };
        PipelineSchema: {
            /** Format: uuid */
            id: string;
            name: string;
            software: components["schemas"]["SoftwareEnumSchema"];
        };
        ProblemDetailsSchema: {
            type?: string | null;
            title?: string | null;
            /** Format: int32 */
            status?: number | null;
            detail?: string | null;
            instance?: string | null;
        } & {
            [key: string]: unknown;
        };
        RawFileSchema: {
            location: string;
            fileName: string;
            /** Format: int64 */
            sizeInBytes: number;
            /** Format: int64 */
            fileCount?: number | null;
            id: string;
        };
        /** @enum {string} */
        SNStepEnumSchema: SNStepEnumSchema;
        /** @enum {string} */
        SettingsTypeEnumSchema: SettingsTypeEnumSchema;
        /** @enum {string} */
        SoftwareEnumSchema: SoftwareEnumSchema;
        SoftwareSettingsMetadataSchema: {
            /** Format: uuid */
            id: string;
            name: string;
            location: string;
            createdBy: string;
            software: components["schemas"]["SoftwareEnumSchema"];
            softwareVersion: string;
            settingsType: components["schemas"]["SettingsTypeEnumSchema"];
            detectedSoftwareVersion?: string | null;
            /** Format: int32 */
            detectedMajorVersion?: number | null;
        };
        /** @enum {string} */
        StatusEnumSchema: StatusEnumSchema;
        StepSchema: {
            name: string;
            /** Format: uuid */
            id: string;
            type: components["schemas"]["SNStepEnumSchema"];
        };
        /** @enum {string} */
        StorageLocationTypeEnumSchema: StorageLocationTypeEnumSchema;
        UpdateSoftwareVersionSchema: {
            enabled?: boolean | null;
            isDefault?: boolean | null;
        };
        UserCredentialsSchema: {
            username: string;
            password: string;
        };
        UserSchema: {
            id?: string | null;
            userName?: string | null;
            normalizedUserName?: string | null;
            email?: string | null;
            normalizedEmail?: string | null;
            emailConfirmed?: boolean;
            passwordHash?: string | null;
            securityStamp?: string | null;
            concurrencyStamp?: string | null;
            phoneNumber?: string | null;
            phoneNumberConfirmed?: boolean;
            twoFactorEnabled?: boolean;
            /** Format: date-time */
            lockoutEnd?: string | null;
            lockoutEnabled?: boolean;
            /** Format: int32 */
            accessFailedCount?: number;
            displayName?: string | null;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    "archives-list": {
        parameters: {
            query: {
                jobCreatedAt: string;
                jobName: string;
                jobAnalysisName?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FileMetadataSchema"][];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "archives/jobs-list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["JobArchiveCandidateSchema"][];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "/auth/oidc-get": {
        parameters: {
            query: {
                redirect_uri: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Redirect */
            301: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "/auth/oidc/exchange-post": {
        parameters: {
            query: {
                /** @description Frontend origin URL (must be in allowed origins list) */
                origin: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Request body containing the OIDC ID token (NOT access token!) */
        requestBody: {
            content: {
                "application/json": components["schemas"]["ExchangeOidcTokenSchema"];
            };
        };
        responses: {
            /** @description Successfully exchanged ID token for access token */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Invalid ID token format, missing required claims, or invalid origin */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description ID token signature validation failed or token expired */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Rate limit exceeded */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "/auth/credentials-put": {
        parameters: {
            query: {
                origin: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserCredentialsSchema"];
            };
        };
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "auth/token-get": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "auth/token-put": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "auth/token-delete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "auth/csrf-token-get": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "fasta-create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "multipart/form-data": {
                    /** Format: binary */
                    file: string;
                };
            };
        };
        responses: {
            /** @description Created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FastaFileSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "fasta-delete": {
        parameters: {
            query: {
                fileName: string;
                folder?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": boolean;
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "fasta-list": {
        parameters: {
            query?: {
                page?: number;
                pageSize?: number;
                sortBy?: string;
                sortDirection?: string;
                fileName?: string;
                folder?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PagedFastaFileListSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "jobs-list": {
        parameters: {
            query?: {
                page?: number;
                pageSize?: number;
                sortBy?: string;
                sortDirection?: string;
                name?: string;
                createdBy?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PagedJobListSchema"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "jobs-update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["JobSchema"];
            };
        };
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["JobSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "jobs-create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateJobSchema"];
            };
        };
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["JobSchema"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "jobs-get": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["JobSchema"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "jobs-delete": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["JobSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "jobs-abort": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["JobSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "jobs-cancel-pending-batches": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["JobSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "jobs-resume": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["JobSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "jobs/{job_id}/steps-list": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["JobPipelineStepDetailSchema"][];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "jobs/{job_id}/steps/{job_pipeline_step_id}-get": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_pipeline_step_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["JobPipelineStepSchema"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "jobs/{job_id}/steps/{job_pipeline_step_id}/batches-list": {
        parameters: {
            query?: {
                page?: number;
                pageSize?: number;
                sortBy?: string;
                sortDirection?: string;
            };
            header?: never;
            path: {
                job_id: string;
                job_pipeline_step_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PagedBatchListSchema"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "jobs/{job_id}/steps/{job_pipeline_step_id}/batches/{batch_id}/logs/{session_id}-get": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
                job_pipeline_step_id: string;
                batch_id: string;
                session_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuditingFileSchema"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "jobs/{job_id}/steps/{job_pipeline_step_id}/batches/{batch_id}/logs/{session_id}-post": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
                job_pipeline_step_id: string;
                batch_id: string;
                session_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuditingFileSchema"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "jobs/{job_id}/steps/{job_pipeline_step_id}/batches/{batch_id}/results/{session_id}-get": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
                job_pipeline_step_id: string;
                batch_id: string;
                session_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuditingFileSchema"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "jobs/{job_id}/steps/{job_pipeline_step_id}/batches/{batch_id}/samples-list": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                batch_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PagedBatchRawFileListSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "libraries-list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FileMetadataSchema"][];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "libraries-upload": {
        parameters: {
            query?: {
                folder?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RawFileSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "license-post": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AddLicenseRequestSchema"];
            };
        };
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LicenseSchema"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "pipelines-get": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PipelineSchema"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "pipelines-steps-get": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                pipeline_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["StepSchema"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "-get": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "sample-inventory-list": {
        parameters: {
            query?: {
                page?: number;
                pageSize?: number;
                sortBy?: string;
                sortDirection?: string;
                name?: string;
                folder?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PagedRawFileListSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "sample-inventory-upload": {
        parameters: {
            query?: {
                folder?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RawFileSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "sample-inventory-upload-init": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["InitiateRawFileUploadSchema"];
            };
        };
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "sample-inventory-upload-chunk": {
        parameters: {
            query: {
                uploadId: string;
                partNumber: number;
                fileName: string;
                folder?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "sample-inventory-upload-complete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CompleteRawFileUploadSchema"];
            };
        };
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RawFileSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "sample-inventory-check": {
        parameters: {
            query: {
                fileName: string;
                folder?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": number;
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "sample-inventory-check-batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CheckRawFilesSchema"];
            };
        };
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: number;
                    };
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "software-settings/spectronaut-create": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                version: string;
                type: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "multipart/form-data": {
                    /** Format: binary */
                    file: string;
                };
            };
        };
        responses: {
            /** @description Created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SoftwareSettingsMetadataSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "software-settings/spectronaut-create-versionless": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                type: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "multipart/form-data": {
                    /** Format: binary */
                    file: string;
                };
            };
        };
        responses: {
            /** @description Created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SoftwareSettingsMetadataSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "software-settings-list": {
        parameters: {
            query: {
                page?: number;
                pageSize?: number;
                sortBy?: string;
                sortDirection?: string;
                fileName?: string;
                type: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PagedSoftwareSettingsMetadataListSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "software-settings-delete": {
        parameters: {
            query: {
                fileName: string;
                type: components["schemas"]["SettingsTypeEnumSchema"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": boolean;
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "software-versions-list": {
        parameters: {
            query?: {
                enabled?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SoftwareVersionSchema"][];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "software-versions-update": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                version: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateSoftwareVersionSchema"];
            };
        };
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SoftwareVersionSchema"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetailsSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "users-put": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateUserSchema"];
            };
        };
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "users-post": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateUserSchema"];
            };
        };
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "users-delete": {
        parameters: {
            query: {
                userId: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
    "users/me/password-put": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ChangeMyPasswordSchema"];
            };
        };
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserSchema"];
                };
            };
            /** @description Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["ProblemDetailsSchema"];
                };
            };
        };
    };
}
export enum FileTypeEnumSchema {
    Results = "Results",
    Logs = "Logs",
    Errors = "Errors"
}
export enum JobPipelineTypeSchema {
    DirectDIA = "DirectDIA",
    LibraryGeneration = "LibraryGeneration",
    LibraryBased = "LibraryBased",
    LibraryGenerationFromArchive = "LibraryGenerationFromArchive"
}
export enum JobPriorityEnumSchema {
    Normal = "Normal",
    Low = "Low",
    High = "High"
}
export enum SNStepEnumSchema {
    DownloadData = "DownloadData",
    PulsarStep1 = "PulsarStep1",
    PulsarStep2 = "PulsarStep2",
    PulsarStep3 = "PulsarStep3",
    LibraryGeneration = "LibraryGeneration",
    DiaAnalysis = "DiaAnalysis",
    SneCombine = "SneCombine",
    SneMerge = "SneMerge"
}
export enum SettingsTypeEnumSchema {
    Experiment = "Experiment",
    Report = "Report",
    GO = "GO",
    Modification = "Modification",
    ConditionSetup = "ConditionSetup"
}
export enum SoftwareEnumSchema {
    Spectronaut = "Spectronaut",
    SpectroDive = "SpectroDive",
    SpectroMine = "SpectroMine",
    Quic = "Quic"
}
export enum StatusEnumSchema {
    Created = "Created",
    Scheduled = "Scheduled",
    Pending = "Pending",
    Running = "Running",
    Completed = "Completed",
    Failed = "Failed",
    Aborted = "Aborted",
    Paused = "Paused"
}
export enum StorageLocationTypeEnumSchema {
    LocalFileSystem = "LocalFileSystem",
    Azure = "Azure",
    AWS = "AWS"
}
